import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";
import isPushSupportedInCurrentiOSAppVersion from "features/pwa/mobile/ios/utils/isPushSupportedInCurrentiOSAppVersion";

export function emitRequestPushPermissions() {
  if (!isPushSupportedInCurrentiOSAppVersion()) {
    return alert(
      "Please update the app to the latest version in order to activate push notifications."
    );
  }

  if (isNativeAppiOS()) {
    window?.webkit?.messageHandlers?.pushRequestPermissions?.postMessage(
      "default"
    );
  }
}

export function emitPushPermissionState() {
  if (isNativeAppiOS()) {
    window?.webkit?.messageHandlers?.pushPermissionState?.postMessage(
      "default"
    );
  }
}

export function emitAuthStateChange(isAuth: boolean) {
  if (isNativeAppiOS()) {
    const state = isAuth ? "signedIn" : "signedOut";

    window?.webkit?.messageHandlers?.authStateChange?.postMessage({
      state
    });
  }
}
